module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/ReserveButton/images/battle-unique-disabled-normal.0d21c42e.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/ReserveButton/images/battle-unique-disabled-normal.png
// module id = 3425
// module chunks = 11